import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Address } from '@infodocs/shared/interfaces/address';

@Pipe({
	name: 'addressToString',
	pure: false
})
export class AddressToStringPipe implements PipeTransform {
	private readonly domSanitizer = inject(DomSanitizer);

	public transform(value: Partial<Address>) {
		const provinceName = this.getName(value.province);
		const countryName = this.getName(value.country);

		return this.domSanitizer.bypassSecurityTrustHtml(
			[
				value.address_1,
				value.address_2,
				value.city,
				value.postal_code,
				provinceName,
				countryName
			].filter(Boolean).join('<br/>')
		);
	}

	private getName(value: unknown): string | undefined {
		if (!value) return undefined;
		if (typeof value === 'string') return value;
		if (typeof value === 'object' && 'name' in value) {
			const name = (value as { name?: unknown }).name;
			return typeof name === 'string' ? name : undefined;
		}

		return undefined;
	}
}
